import { FC } from 'react'
import { BooleanInput, Edit, NumberInput, SimpleForm, TextInput, useTranslate } from 'react-admin'
import { InputAdornment } from '@mui/material'

const WorkflowEditForm: FC = () => {
  const translate = useTranslate()
  return (
    <SimpleForm>
      <TextInput source="display_name" fullWidth />
      <TextInput source="description" multiline rows={3} fullWidth />
      <TextInput source="about" multiline rows={6} fullWidth />
      <BooleanInput source="enabled" />
      <BooleanInput source="auto_approve" />
      <BooleanInput source="marketplace" label="data.marketplaceVisible" />
      <NumberInput
        source="cost_per_workflow_execution"
        label={translate('workflow.costPerWorkflowExecution')}
        helperText={translate('workflow.costPerWorkflowExecutionHelp')}
        min={0}
        step={0.0001}
        fullWidth
        InputProps={{ startAdornment: <InputAdornment position="start">€</InputAdornment> }}
      />
    </SimpleForm>
  )
}

const WorkflowEdit: FC = () => (
  <Edit mutationMode="pessimistic">
    <WorkflowEditForm />
  </Edit>
)

export default WorkflowEdit
